import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';

import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
Sentry.init({
	dsn: 'https://1b1d5feeb514254c959e0f6583780803@logs.smoothr.de/3',
	enabled: !!environment.production,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: false,
			maskAllInputs: true,
			blockAllMedia: false,
			stickySession: true,
		}),
	],
	tracesSampleRate: 1.0,
	profilesSampleRate: 1.0,
	replaysSessionSampleRate: 1.0,
	replaysOnErrorSampleRate: 1.0,
	environment: environment.production ? 'production' : 'development',
});

if (environment.production) {
	enableProdMode();
}
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
